import ip from 'icepick';

import Store from '../types/store';
import { getInitBookingData } from '../utils/booking';
import { getInitPrebookingData } from '../utils/prebooking';
import {
  SET_DYNAMIC_BOOKING_DETAILS,
  SET_NEARBY_PROJECTS,
  SET_BOOKINGS,
  SET_PROJECTS,
  SET_RECENT_PROJECTS,
  SET_ALL_PROJECTS,
  SET_SELECTED_DATE,
  SET_SELECTED_PROJECT,
  SET_SELECTED_VEHICLE,
  SET_STATIC_BOOKING_DETAILS,
  SET_PAYMENT_HISTORY_CONTAINER,
  SET_REFERRAL_CODE,
} from './type';

const initialState: Store = ip.freeze({
  prebooking: getInitPrebookingData(),
  booking: getInitBookingData(),
});

const setPrebookingPayload = (state, action, field: string) =>
  ip.setIn(state, ['prebooking', field], action.payload);

const setBookingPayload = (state, action, field: string) =>
  ip.setIn(state, ['booking', field], action.payload);

const valetV2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_VEHICLE: {
      state = setPrebookingPayload(state, action, 'selectedVehicle');
      return state;
    }
    case SET_SELECTED_PROJECT: {
      state = setPrebookingPayload(state, action, 'selectedProject');
      return state;
    }
    case SET_SELECTED_DATE: {
      state = setPrebookingPayload(state, action, 'selectedDate');
      return state;
    }
    case SET_PROJECTS: {
      state = setPrebookingPayload(state, action, 'projects');
      return state;
    }
    case SET_RECENT_PROJECTS: {
      state = setPrebookingPayload(state, action, 'recentProjects');
      return state;
    }
    case SET_NEARBY_PROJECTS: {
      state = setPrebookingPayload(state, action, 'nearbyProjects');
      return state;
    }
    case SET_ALL_PROJECTS: {
      state = setPrebookingPayload(state, action, 'allProjects');
      return state;
    }
    case SET_BOOKINGS: {
      state = setPrebookingPayload(state, action, 'bookings');
      return state;
    }

    case SET_STATIC_BOOKING_DETAILS: {
      state = setBookingPayload(state, action, 'staticBookingDetailsContainer');
      return state;
    }

    case SET_DYNAMIC_BOOKING_DETAILS: {
      state = setBookingPayload(
        state,
        action,
        'dynamicBookingDetailsContainer'
      );
      return state;
    }

    case SET_PAYMENT_HISTORY_CONTAINER: {
      state = setBookingPayload(state, action, 'paymentHistoryContainer');
      return state;
    }

    case SET_REFERRAL_CODE: {
      state = setBookingPayload(state, action, 'referralCodeContainer');
      return state;
    }

    default: {
      return state;
    }
  }
};

export default valetV2Reducer;
